export default __webpack_public_path__ + "static/media/mittel.eedad430.jpg";